import { render, staticRenderFns } from "./UniversalModal.vue?vue&type=template&id=d52b91a0&"
import script from "./UniversalModal.vue?vue&type=script&lang=js&"
export * from "./UniversalModal.vue?vue&type=script&lang=js&"
import style0 from "./UniversalModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports